export const USERS_LOADED = "adminUsers/USERS_LOADED";
export const USERS_LOAD_FAILED = "adminUsers/USERS_LOAD_FAILED";
export const RESET = "adminUsers/RESET";
